import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'exa-meters',
  template: `<router-outlet></router-outlet>`,
  styles: []
})
export class MetersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
